
export const getCustomField = (career, internalName) =>
    career?.custom_fields.find(field => field.internal_name === internalName)?.value;

export const isCountryVacancyRelated = (countries, countryCode) =>
    countries.some(code => code.toLowerCase() === countryCode?.toLowerCase());
